import type { FC } from "react";
import React, { useMemo } from "react";

import { getChildrenRecord } from "../../../../../utils/react";
import { UniBoxAdditional } from "../../../../UniBox";
import { TAG_SIZE_BY_AVA_PICTURE_SIZE_MAP } from "../../../constants/sizes";
import { createDisplayNameForAvaPictureElement } from "../../../utils/getDisplayName";
import { createTestIdForAvaPictureElement } from "../../../utils/getTestId";

import type { AvaPictureSizes } from "../../../types";

import classes from "./AvaPictureSlotBottom.styl";

type AvaPictureSlotBottomPrivateProps = {
    size: AvaPictureSizes;
    children: React.ReactElement;
};

type AvaPictureSlotBottomProps = Omit<AvaPictureSlotBottomPrivateProps, "size">;

const AVA_PICTURE_SLOT_BOTTOM_DISPLAY_NAME =
    createDisplayNameForAvaPictureElement("SlotBottom");

const AVA_PICTURE_SLOT_BOTTOM_TEST_ID =
    createTestIdForAvaPictureElement("SlotBottom");

export const AvaPictureSlotBottom: FC<AvaPictureSlotBottomProps> = (props) => {
    const { size, children } = props as AvaPictureSlotBottomPrivateProps;

    const { Tag } = useMemo(
        () =>
            getChildrenRecord(children, AVA_PICTURE_SLOT_BOTTOM_DISPLAY_NAME, {
                Tag: {
                    props: { size: TAG_SIZE_BY_AVA_PICTURE_SIZE_MAP[size] },
                    required: true,
                },
                Unknown: {
                    skipElement: true,
                },
            }),
        [children, size],
    );

    const shouldShowChild = ["16", "20", "24", "36", "44"].indexOf(size) === -1;

    return (
        <UniBoxAdditional.SlotBottom
            data-tsid={AVA_PICTURE_SLOT_BOTTOM_TEST_ID}
            customVarsStyles={classes["tag-offset"]}
        >
            {shouldShowChild && Tag}
        </UniBoxAdditional.SlotBottom>
    );
};

AvaPictureSlotBottom.displayName = AVA_PICTURE_SLOT_BOTTOM_DISPLAY_NAME;

export default AvaPictureSlotBottom;
